import { Toaster } from '@/components/ui/sonner';

export default function MainLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-svh flex-col">
      <main className="">{children}</main>
      <Toaster richColors expand={false} visibleToasts={1} position="top-center" />
    </div>
  );
}
